import { INSIDER_LOGGED_OUT_LANDING_PAGE_V2_241007 } from "@faire/web-api/indigofair/settings/INSIDER_LOGGED_OUT_LANDING_PAGE_V2_241007";

import {
  useSetting,
  useAssignSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingInsiderLoggedOutLandingPageV2 = (): boolean =>
  useSetting(INSIDER_LOGGED_OUT_LANDING_PAGE_V2_241007, false);

export const useAssignSettingInsiderLoggedOutLandingPageV2 = () =>
  useAssignSetting(INSIDER_LOGGED_OUT_LANDING_PAGE_V2_241007);
